'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Mobilenav = {
	init: function init() {
		(0, _jquery2.default)('.burger').on('click', function () {
			(0, _jquery2.default)('.mobile-navigation-wrapper').toggleClass('open');
			(0, _jquery2.default)('body').toggleClass('opennav');
		});
		(0, _jquery2.default)('.closenav').on('click', function () {
			(0, _jquery2.default)('.mobile-navigation-wrapper').toggleClass('open');
			(0, _jquery2.default)('body').toggleClass('opennav');
		});
	}
};

exports.default = Mobilenav;